/*
 * render exceed line for given `svg`, `y` and `width`
 */
export default ({
  svg,
  y,
  width
}) => {
  const _y = y(50)
  svg.append('g')
    .append('line')
      .attr('class', 'history-chart__exceed-line')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', _y)
      .attr('y2', _y)
}



// WEBPACK FOOTER //
// ./src/components/station-infobox/draw_exceed_line.js